import { inject, Injectable } from '@angular/core';
import { SsrBrowserContextService } from './ssrBrowserContextService';

@Injectable({
  providedIn: 'root'
})

export class StorageService {
  isSsrBrowserContextService = inject(SsrBrowserContextService)
  //platformId = inject(PLATFORM_ID);
  
  set(key: string, value: string) {
    if (!this.isSsrBrowserContextService.isBrowser)
        return;

    sessionStorage.setItem(key, value);
  }

  get(key: string): string | null {
    if (!this.isSsrBrowserContextService.isBrowser) 
        return null;

    return sessionStorage.getItem(key);
  }

  remove(key: string) {
    if (!this.isSsrBrowserContextService.isBrowser)
        return;

    sessionStorage.removeItem(key);
  }
}